<template>
  <div>
	<div class="data31">
		<div class="data31Til">光源可选·按需满足</div>
		<div class="data31Box">
			<div class="data31BoxList" v-for="(item,index) in list" :key="index">
				<div class="data31BoxListImg">
					<img :src="item.img" />
				</div>
				<div class="data31BoxListWz">
					<div class="data31BoxListWzName">
						{{item.name}}
					</div>
					<div class="data31BoxListWzCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		list:[
			{
				img:require('@/assets/product/page8/ledgy.png'),
				name:'XE氙灯',
				cen:'显色性强'
			},
			{
				img:require('@/assets/product/page8/ledgy.png'),
				name:'LED光源',
				cen:'光源寿命长'
			},
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data31{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.data31Til{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 73px;
	}
	.data31Box{
		display: flex;
		justify-content: space-between;
		.data31BoxList:not(:last-child){
			margin-right: 40px;
		}
		.data31BoxList:hover{
			.data31BoxListImg{
				img{
					transform: scale(1.1);
				}
			}
		}
		.data31BoxList{
			
			.data31BoxListImg{
				margin-bottom: 33px;
				width: 580px;
				height: 580px;
				overflow: hidden;
				img{
					width: 580px;
					height: 580px;
					// object-fit: cover;
					transition: all 0.3s ease-in-out;
				}
			}
			.data31BoxListWz{
				display: flex;
				.data31BoxListWzName{
					margin-right: 20px;
					font-size: 26px;
					
					font-weight: bold;
					color: #000000;
				}
				.data31BoxListWzCen{
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
				}
			}
		}
	}
}
</style>
